module.exports = __webpack_public_path__ + "static/img/content.9540b8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/dialog/rules/content.png
// module id = ittm
// module chunks = 6